export const FRESH_CX_PHONE = {
  link: '+16467807957',
  display: '(646) 780-7957',
};

export const PHASE2_HERO_CX_PHONE = {
  link: '+18774148444',
  display: '(877) 414-8444',
};
